export default __webpack_public_path__ + "static/media/display.6a83759c.svg";